import { Edit, SimpleForm, useGetIdentity } from "react-admin";
import { SaveOnlyToolbar } from "../../components/SaveOnlyToolbar";
import { UserForm } from "./UserForm";
import { useUpdateSubmit } from "../../forms";

const UserEditForm = () => {
	const submit = useUpdateSubmit("users", "User updated");
	const { data: userIdentity } = useGetIdentity();

	return (
		<SimpleForm onSubmit={submit} toolbar={<SaveOnlyToolbar />}>
			<UserForm showAdminField={userIdentity?.admin} />
		</SimpleForm>
	);
};

export const UserEdit = () => (
	<Edit title="Update user">
		<UserEditForm />
	</Edit>
);
